import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/elfsquad.webp';
import screenshot_target from '../../../images/letterfunnel/janbrolsma.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jan Brolsma"
      firstname="Jan"
      companyname="Elfsquad"
      competition="Hive CPQ en Epicor CPQ"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/janbrolsma.js